import {
  BookOpen,
  CalendarDays,
  ChartPie,
  FileText,
  Handshake,
  LayoutDashboard,
  MessagesSquare,
} from 'lucide-react'
import type { NavSection } from '../types'

/** Investor navigation (NAV-001, PRD §6.12). Add an entry here and a route in ./routes.tsx. */
export const appNav: NavSection[] = [
  {
    items: [
      {
        label: 'Dashboard',
        to: '/app',
        icon: LayoutDashboard,
        end: true,
        activeFor: ['/app/updates'],
      },
      { label: 'Portfolio', to: '/app/portfolio', icon: ChartPie, activeFor: ['/app/companies'] },
      { label: 'Engagements', to: '/app/engagements', icon: Handshake, activeFor: ['/app/cases'] },
      { label: 'Calendar', to: '/app/calendar', icon: CalendarDays, activeFor: ['/app/meetings'] },
      { label: 'Requests', to: '/app/requests', icon: MessagesSquare },
      { label: 'Reports', to: '/app/reports', icon: FileText },
      { label: 'Methodology', to: '/app/methodology', icon: BookOpen },
    ],
  },
]
